import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="254"
      height="124"
      viewBox="0 0 254 124"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#F1F1F1">
          <g>
            <g>
              <g transform="translate(-762 -248) translate(350 160) translate(412.986 88.15)">
                <rect width="79.775" height="9.075" rx="2" />
                <rect width="252.62" height="9.075" y="18.975" rx="2" />
              </g>
              <g transform="translate(-762 -248) translate(350 160) translate(412.986 88.15) translate(0 47)">
                <rect width="79.775" height="9.075" rx="2" />
                <rect width="252.62" height="9.075" y="18.975" rx="2" />
              </g>
              <g transform="translate(-762 -248) translate(350 160) translate(412.986 88.15) translate(0 94)">
                <rect width="79.775" height="9.075" rx="2" />
                <rect width="252.62" height="9.075" y="18.975" rx="2" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
